import type { ComponentRegistry } from '@vibesites/runtime';
import {
  Header,
  Hero,
  HeroCallouts,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  ImageCallouts,
  FloorplansList,
  AmenitiesList,
  GalleryGrid,
  GalleryApartments,
  GallerySeparator,
  GalleryCommunity,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  ApplyNow,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
  ParallaxBanner,
  FAQList,
} from './components';

export const registry: ComponentRegistry = {
  Header,
  Hero,
  HeroCallouts,
  PropertyOverview,
  SpecialOffers,
  CTASection,
  ImageCallouts,
  FloorplansList,
  AmenitiesList,
  GalleryGrid,
  GalleryApartments,
  GallerySeparator,
  GalleryCommunity,
  NeighborhoodMap,
  VirtualTourEmbed,
  ContactForm,
  ContactMap,
  ScheduleTourForm,
  Fees,
  PetPolicy,
  PageHero,
  PageBlurb,
  HeroSolidBG,
  Reviews,
  ReviewsCallout,
  SocialFollow,
  SpecialOfferBanner,
  ResidentAccess,
  ApplyNow,
  AccessibilityStatement,
  PrivacyPolicyContent,
  SitemapContent,
  HyperlocalHero,
  HyperlocalPageCopy,
  ThankYouContent,
  FutureResidentsClub,
  ApartmentSyncSection,
  Footer,
  Navigation,
  InteractiveMapSection,
  ParallaxBanner,
  FAQList,
};

export default registry;
